

export const nativeLogTypeConfigs = [
  {
    logType: 1,
    logTypeName: "exception catch 日志",
    displayColor: "#32CD32"
  },
  {
    logType: 2,
    logTypeName: "custom 代码日志",
    displayColor: "#2f54eb"
  },
  {
    logType: 3,
    logTypeName: "network日志",
    displayColor: "#5c3317"
  },
  {
    logType: 84,
    logTypeName: "性能日志",
    displayColor: "#5c3317"
  },
  {
    logType: 101,
    logTypeName: "终端 INFO 日志",
    displayColor: "#13a8a8"
  },
  {
    logType: 102,
    logTypeName: "终端 WARN 日志",
    displayColor: "#faad14"
  },
  {
    logType: 103,
    logTypeName: "终端 ERROR 日志",
    displayColor: "#f5222d"
  },
  {
    logType: 104,
    logTypeName: "终端事件日志",
    displayColor: "#722ed1"
  },
  {
    logType: 105,
    logTypeName: "终端网络日志",
    displayColor: "#1890ff"
  }
];

export const webLogTypeConfigs = [
  {
    logType: 1,
    logTypeName: "日志类型1",
    displayColor: "#32CD32"
  },
  {
    logType: 2,
    logTypeName: "日志类型2",
    displayColor: "#2f54eb"
  },
  {
    logType: 3,
    logTypeName: "日志类型3",
    displayColor: "#5c3317"
  }
];
